const { algoliasearch, instantsearch } = window;
const searchClient = algoliasearch('KMRVXWVIQV', 'YzY1MjZkOGM0MjZiZDA0OWFkY2YxYTA1YzQ1YmUyZmNiYjcxNmY1MDY2MTFjMzgyMzQ0MWY3YTJkMmRjNTFjM3Jlc3RyaWN0SW5kaWNlcz1jZG5fcGlsb3RfdjEqJm51bWVyaWNGaWx0ZXJzPSU1QiU1QiUyMnZpc2liaWxpdHklM0UyMDAlMjIlNUQlNUQ=');
const indexName = 'cdn_pilot_v1';
const widgetsForAttributes = {
  'meta.productcategory': 'menu',
  'meta.productfamily': 'menu',
  'meta.publicationtype': 'refinementList',
  'format': 'menu',
  'lang': 'menu',
};

let url = window.location.href.split('?')[0];
let params = new URLSearchParams(window.location.search);
if (!params.has('format')) params.set('format', 'web');
if (!params.has('lang')) params.set('lang', 'en-GB');
window.history.replaceState(history.state, "", url + "?" + params.toString());

const search = instantsearch({
  searchClient,
  indexName: indexName,
  routing: {
    stateMapping: {
      stateToRoute(uiState) {
        const state = uiState[indexName];
        const route = {
          query: state.query,
          page: state.page
        };
        ['refinementList', 'hierarchicalMenu', 'menuSelect', 'menu'].forEach((widget) => {
          if (state[widget]) {
            for (var attribute in state[widget]) {
              route[attribute] = state[widget][attribute];
            }
          }
        });
        return route;
      },
      routeToState(routeState) {
        const state = {
          [indexName]: {
            refinementList: {},
            hierarchicalMenu: {},
            menuSelect: {},
            menu: {},
          },
        };
        for (const key in routeState) {
          if (key in widgetsForAttributes) {
            const widget = widgetsForAttributes[key];
            state[indexName][widget][key] = routeState[key];
            continue;
          }
          ['query', 'page'].forEach((attribute) => {
            if (key === attribute) {
              state[indexName][attribute] = routeState[key];
            }
          });
        }
        return state;
      },
    },
  },
});

function get(fallback, obj, level, ...rest) {
  if ((obj === undefined) || (obj === null)) return fallback;
  if (rest.length === 0 && obj.hasOwnProperty(level)) {
      if ((obj[level] === null) && (fallback !== null)) return fallback;
      return obj[level];
  }
  return get(fallback, obj[level], ...rest);
}

function set(obj, level, ...rest) {
  if ((obj === undefined) || (obj === null)) throw Error("Invalid object supplied!");
  if ((level === undefined) || (level === null)) throw Error("At least one level must be supplied");
  if (rest.length === 0) throw Error("A value must be supplied as the last argument!");
  if (rest.length === 1) {
    obj[level] = rest[0];
  } else {
    set(obj[level], ...rest);
  }
}

function transformItems(attributes, items) {
  if (attributes) {
    if (!Array.isArray(attributes)) attributes = [attributes];
    // a specific attribute (facet)
    return items.map((item) => {
      for (const attribute of attributes) {
        if ((attribute in transformations) && (item.label in transformations[attribute])) {
          return {
            ...item,
            label: transformations[attribute][item.label],
            highlighted: transformations[attribute][item.label],
          };
        }
      }
      return item;
    });
  } else {
    // search results
    return items.map((item) => {
      let result = Object.assign({}, item);
      for (let attribute in item) {
        if ((attribute in transformations) && (item[attribute] in transformations[attribute])) {
          result = {
            ...result,
            [attribute]: transformations[attribute][item[attribute]]
          };
        } else {
          Object.keys(transformations).forEach((attribute) => {
            let fields = attribute.split('.');
            if (fields.length > 0) {
              let value = get(null, item, ...fields);
              if ((value != null) && (value in transformations[attribute])) {
                set(result, ...fields, transformations[attribute][value]);
              }
            }
          })
        }
      }
      return result;
    });
  }
}

// Modularize card content based on eservices or instruction
function getCardTemplate(hit) {
  console.log(hit);
  return `
      <article class="card">
  ${getCardHeader(hit)}
  <div class="card-body">
    <p class="card-text">
    <b>${hit.meta.model}</b>
    <br>
     ${getCardBody(hit)}
    </div>
  ${getCardFooter(hit)}    
  </article>`
}

function getCardBody(hit) {
  if (hit.meta.publicationtype === 'E-Services Instructions') {
    return `
      PartNo: ${hit.meta.softwarepartnumber || 'N/A'}<br>
      Version: ${hit.meta.softwareversion}`;
  } else {
    const variantText = Array.isArray(hit.meta.variant)
      ? hit.meta.variant.join(' | ')
      : hit.meta.variant || ' ';  
      
    return `
      ${variantText || ''}<br>
      Serial No: ${hit.meta.serialno || 'N/A'}`;
  }
}


function getCardHeader(hit) {
  return `<div class="card-header">
  <a class="link-primary text-decoration-none" href="${hit.url}">
  <h5 class="card-title">${hit.meta.publicationtype} | ${hit.meta.productfamily}</h5></a>
  </div>`
}

function getCardFooter(hit) {
  
  return  `
  <div class="card-footer">
  <div class="row justify-content-end">
    <div class="col">
      <a class="link-primary text-decoration-none" href="${ hit.url }">
      <span class="text-uppercase">${ hit.docno }</span> [${ hit.versionrelease}] 
      </a>
    </div>
    <div class="col-auto">
      <language-picker
        size="sm"
        lazy="true"
        class="navbar-language-picker"
        variant="lp"
        menuVariant="lp"
        docno="${hit.docno}"
        default="${hit.lang}"
        version="${hit.version}"
        urlprefix=""
        algoliaAppId="KMRVXWVIQV"
        algoliaApiKey="YzY1MjZkOGM0MjZiZDA0OWFkY2YxYTA1YzQ1YmUyZmNiYjcxNmY1MDY2MTFjMzgyMzQ0MWY3YTJkMmRjNTFjM3Jlc3RyaWN0SW5kaWNlcz1jZG5fcGlsb3RfdjEqJm51bWVyaWNGaWx0ZXJzPSU1QiU1QiUyMnZpc2liaWxpdHklM0UyMDAlMjIlNUQlNUQ="
        algoliaIndexName="cdn_pilot_v1"
      ></language-picker>
    </div>
    </div>
</div>`
}

search.addWidgets([
  instantsearch.widgets.searchBox({
    container: '#searchbox',
  }),
  instantsearch.widgets.hits({
    container: '#hits',
    transformItems: transformItems.bind(this, null),
    templates: {
      item: (hit) => {
        // Continue to return the template for the item
        return getCardTemplate(hit);
      },
    },
  }),
  instantsearch.widgets.menu({
    container: '#meta-productgroup-menu',
    transformItems: transformItems.bind(this, 'meta.productcategory'),
    attribute: 'meta.productcategory',
    cssClasses: {
      link: 'link-primary',
    },
  }),
  instantsearch.widgets.menu({
    container: '#meta-productfamily-menu',
    transformItems: transformItems.bind(this, 'meta.productfamily'),
    attribute: 'meta.productfamily',
    limit: 20,
    cssClasses: {
      link: 'link-primary',
    },
  }),
  instantsearch.widgets.refinementList({
    container: '#meta-type-list',
    transformItems: transformItems.bind(this, 'meta.publicationtype'),
    attribute: 'meta.publicationtype',
  }),
  instantsearch.widgets.menuSelect({
    container: '#format-select',
    transformItems: transformItems.bind(this, 'format'),
    attribute: 'format',
    templates: {
      defaultOption: 'Any',
    }
  }),
  instantsearch.widgets.menuSelect({
    container: '#lang-select',
    transformItems: transformItems.bind(this, 'lang'),
    attribute: 'lang',
    templates: {
      defaultOption: 'Any',
    }
  }),
  instantsearch.widgets.pagination({
    container: '#pagination',
  }),
  instantsearch.widgets.configure({}),
]);

search.start();
